import React from 'react';
import "./Inputs.css";

export default function InputWlabel({ onchange, classes, fromDB, value, array, label, edit, type, min, max, att, row, column, options }) {

  let arr = array ? array : []



  return (
    <div className={`inputWlabel ${row ? "row-flex-start " : column ? "column-flex-start" : "row-flex-start "} ${classes ? classes : ""} `}>
      <label className='inputwlabel-label' htmlFor={att}> {label} </label>
      {options ? (
        <select onChange={onchange} className='inputwlabel-input  '>
          {edit ?          <option className='inputwlabel-input ' value={value}> {value} </option> :           <option className='inputwlabel-input white' value="">Elegí una opción</option> }


           {arr.map((option, index) => (
            <option  className='inputwlabel-input ' key={index} value={fromDB === true ? option.name : option}>
              
              {fromDB ? option.name.toUpperCase() : option.toUpperCase()}
              
              </option>
          ))}
        </select>
      ) : (
<input
  onChange={onchange}
  type={type}
  min={min}
  max={max}
  id={att}
  value={value ? value : undefined}
  className='inputwlabel-input'
/>
      )}
    </div>
  );
}
